'use client';

import { useState } from 'react';

import { FlatQuotationLine } from '@ravago/shared/page-data/models/elements';
import { Flyout, FlyoutHeader } from '@ravago/shared/radiance/components/flyout/components/Flyout/Flyout';
import { useTranslations } from '@ravago/shared/translations/client';

import { QuoteProductPriceItem } from '../models/quote-product-price-item.model';

import { QuoteProductMobileList } from './quote-product-mobile-list';
import { QuoteProductPriceDetails } from './quote-product-price-details';

interface Props {
   quoteProductPriceItems: QuoteProductPriceItem[];
   productDetailBaseRoute: string;
   documentsAnchor: string;
   channelName: string;
   validUntil: string;
   canViewPrices: boolean;
   showShoppingCartBtn: boolean;
   hasOrderingPermission: boolean;
   isOrderingBlocked: boolean;
   bracketPricingEnabled?: boolean;
   leadTimeEnabled?: boolean;
   deliveryAddressId?: number;
   onAddToCart: (line: FlatQuotationLine, quantity: number) => void;
}

export const QuoteProductPriceSelectorMobile = ({
   quoteProductPriceItems,
   productDetailBaseRoute,
   documentsAnchor,
   channelName,
   validUntil,
   canViewPrices,
   showShoppingCartBtn,
   hasOrderingPermission,
   isOrderingBlocked,
   bracketPricingEnabled = false,
   leadTimeEnabled = false,
   deliveryAddressId,
   onAddToCart
}: Props) => {
   const translate = useTranslations();

   const [selectedProductId, setSelectedProductId] = useState<string | undefined>(undefined);
   const [flyoutOpen, setFlyoutOpen] = useState(false);

   const selectedProduct = quoteProductPriceItems.find((product) => product.id === selectedProductId);

   const handleViewPrices = (productId: string) => {
      setSelectedProductId(productId);
      setFlyoutOpen(true);
   };

   return (
      <>
         <QuoteProductMobileList
            products={quoteProductPriceItems}
            productDetailBaseRoute={productDetailBaseRoute}
            documentsAnchor={documentsAnchor}
            leadTimeEnabled={leadTimeEnabled}
            deliveryAddressId={deliveryAddressId}
            onViewPrices={handleViewPrices}
         />

         <Flyout open={flyoutOpen} onFlyoutClose={() => setFlyoutOpen(false)}>
            <FlyoutHeader>{translate('prices.pricing-table')}</FlyoutHeader>
            {selectedProduct && (
               <QuoteProductPriceDetails
                  key={selectedProduct.id}
                  variant="flyout"
                  product={selectedProduct}
                  productDetailBaseRoute={productDetailBaseRoute}
                  documentsAnchor={documentsAnchor}
                  channelName={channelName}
                  validUntil={validUntil}
                  canViewPrices={canViewPrices}
                  showShoppingCartBtn={showShoppingCartBtn}
                  hasOrderingPermission={hasOrderingPermission}
                  isOrderingBlocked={isOrderingBlocked}
                  bracketPricingEnabled={bracketPricingEnabled}
                  leadTimeEnabled={leadTimeEnabled}
                  deliveryAddressId={deliveryAddressId}
                  onAddToCart={onAddToCart}
               />
            )}
         </Flyout>
      </>
   );
};
